/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : TicketsIndex.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import CommonBreadcrumbs from "../../../components/customComponentsV2/common/Breadcrumbs/CommonBreadcrumbs";
import CustomFilterV2 from "../../../components/customComponentsV2/common/filter/CustomFilterV2";
import CustomRadioButtonV2 from "../../../components/customComponentsV2/common/radioButton/CustomRadioButtonV2";
import CustomCheckBoxV2 from "../../../components/customComponentsV2/common/checkBox/CustomCheckBoxV2";
import ProjectVariantDialog from "../../../components/customComponentsV2/vlc/ProjectVarientAccordian/ProjectVariantDialog";
import ProjectvariantSearchbar from "../../../components/customComponentsV2/common/projectSearchbar/ProjectvariantSearchbar";
import CustomTabsV3 from "../../../components/customComponentsV2/common/tabs/CustomTabsV3";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";
import TicketsTable from "../intersections/TicketsTable";
import { TICKETS_TYPES } from "../../../config/appConstants";
import { useDispatch, useSelector } from "react-redux";
import { HandleApiActions } from "../../../redux/actions";
import typeApprovalAPI from "../../../redux/actions/typeApprovalAPI";
import moment, { max } from "moment/moment";
import CustomFilterTemplate from "../../../components/customComponentsV2/common/filter/CustomFilterTemplate";
import SortTemplate from "../../../components/customComponentsV2/common/Templates/SortTemplate";
import TicketsFilter from "./TicketsFilter";
import CustomTabsV2 from "../../../components/customComponentsV2/common/tabs/CustomTabsV2";
import actionType from "../../../redux/actionTypes";
import reportTemplateAction from "../../../redux/actions/reporting/reportTemplateActions";
import CustomSelectV2 from "../../../components/customComponentsV2/common/select/CustomSelectV2";

function TicketsIndex() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const tabFromUrl = parseInt(searchParams.get("tab")) || 0;
  const selectedProject = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails,
  );
  const selectedVariant = useSelector(
    (state) => state.projectConfigReducer.selectedVariantDetails,
  );

  const [selectedTicketType, setSelectedTicketType] = useState(null);

  const [ticketDetails, setTicketDetails] = useState([]);
  const [selectedIntersectionIds, setSelectedIntersectionIds] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedVarientId, setSelectedVarientId] = useState(null);
  const [page] = useState(1);
  const [rowsPerPage] = useState(25);
  const [totalCount, setTotalCount] = useState(0);
  const [filterData, setFilterData] = useState({});

  const [generateOpen, setGenerateOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [loadingGenerate, setLoadingGenerate] = useState(false);

  const templates = useSelector(
    (state) => state.reportTemplateReducer?.items || [],
  );

  useEffect(() => {
    console.log("templates =", templates);
  }, [templates]);

  useEffect(() => {
    if (!generateOpen) return;

    dispatch(
      HandleApiActions({
        ...reportTemplateAction.get_templates,
      }),
    );
  }, [generateOpen]);

  const memoizedProjectVariant = useMemo(
    () => ({
      projectId: selectedProject?.project_id,
      variantId: selectedVariant?.variant_id,
    }),
    [selectedProject?.project_id, selectedVariant?.variant_id],
  );

  // const fetchTickets = useCallback(
  //   async (requestObj = {}) => {
  //     if (selectedTicketType) {
  //       console.log("---filterdata---");
  //       // debugger;
  //       const resp = await dispatch(
  //         HandleApiActions({
  //           ...typeApprovalAPI?.get_tickets,
  //           params: {
  //             project_id: memoizedProjectVariant.projectId,
  //             variant_id: memoizedProjectVariant.variantId,
  //             page_size: rowsPerPage,
  //             page_number: page,
  //             status: "100,150,200,300,400,500,600,999",
  //             tickets_type: selectedTicketType,
  //             ...filterData,
  //             ...requestObj,
  //           },
  //           show_toast: false,
  //         })
  //       );
  //       // debugger;
  //       console.log("respresp", resp);
  //       if (resp.error) {
  //         setTicketDetails([]);
  //       } else {
  //         const safeData = Array.isArray(resp?.data) ? [...resp.data] : [];

  //         // console.log("---sorted data---", sortedData);
  //         setTicketDetails(safeData);
  //         console.log("resp.data", resp?.data);
  //         setTotalCount(resp?.total_count);
  //       }
  //     }
  //   },
  //   [
  //     dispatch,
  //     memoizedProjectVariant.projectId,
  //     memoizedProjectVariant.variantId,
  //     rowsPerPage,
  //     page,
  //     selectedTicketType,
  //     filterData,
  //   ]
  // );

  const fetchTickets = useCallback(
    async (requestObj = {}) => {
      if (!selectedTicketType) return;

      try {
        const resp = await dispatch(
          HandleApiActions({
            ...typeApprovalAPI?.get_tickets,
            params: {
              project_id: memoizedProjectVariant.projectId,
              variant_id: memoizedProjectVariant.variantId,
              page_size: rowsPerPage,
              page_number: page,
              status: "100,150,200,300,400,500,600,999",
              tickets_type: selectedTicketType,
              ...filterData,
              ...requestObj,
            },
            show_toast: false,
          }),
        );
        // debugge

        if (resp?.error) {
          setTicketDetails([]);
          setTotalCount(0);
          return;
        }

        /**
         * 🔥 IMPORTANT
         * Clone array to avoid mutation from Redux / table / sort
         */
        const safeData = Array.isArray(resp?.data) ? [...resp.data] : [];

        setTicketDetails(JSON.parse(JSON.stringify(resp.data)));
        setTotalCount(resp?.total_count || 0);

        console.log(
          "SAFE ORDER",
          safeData.map((i) => i.created_at),
        );
      } catch (err) {
        console.error("fetchTickets error", err);
        setTicketDetails([]);
        setTotalCount(0);
      }
    },
    [
      dispatch,
      memoizedProjectVariant.projectId,
      memoizedProjectVariant.variantId,
      rowsPerPage,
      page,
      selectedTicketType,
      filterData,
    ],
  );

  const handleGenerate = async () => {
    try {
      setLoadingGenerate(true);

      const resp = await dispatch(
        HandleApiActions({
          api_name: "/PCM/reports/generate",
          https_method: "POST",
          params: {
            scope_type: "VEHICLE_PROGRAM",
            project_id: selectedProjectId, // ensure this exists
            variant_id: selectedVarientId,
            template_id: selectedTemplateId,
          },
          show_toast: true,
        }),
      );

      const s3Key = resp?.data?.s3_key;
      if (!s3Key) return;

      // Get signed URL
      const signed = await dispatch(
        HandleApiActions({
          api_name: "/FSM/v1/assets/download/get/presigned-url",
          https_method: "GET",
          params: { key: s3Key },
          show_toast: false,
        }),
      );

      const url = signed?.data?.url;
      if (url) window.open(url, "_blank");

      setGenerateOpen(false);
      setSelectedTemplateId("");
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingGenerate(false);
    }
  };

  useEffect(() => {
    setSelectedProjectId(memoizedProjectVariant.projectId);
    setSelectedVarientId(memoizedProjectVariant.variantId);
    if (memoizedProjectVariant.projectId && memoizedProjectVariant.variantId) {
      fetchTickets();
    }
  }, [memoizedProjectVariant, fetchTickets]);

  const handleTabChange = (tabIndex) => {
    const ticketTypes = [
      TICKETS_TYPES.VEHICLE_SYSTEM,
      TICKETS_TYPES.VEHICLE_COMPONENT,
      TICKETS_TYPES.EE,
      TICKETS_TYPES.SWM,
    ];
    setSelectedTicketType(ticketTypes[tabIndex]);
    setTicketDetails([]);
  };
  return (
    <Grid container>
      <Grid container>
        <Grid item sm={12} sx={{ p: 1 }}>
          <CommonBreadcrumbs
            items={[{ label: "Regulatory Compliance" }, { label: "Tickets" }]}
          />
        </Grid>
      </Grid>

      <Grid container sx={{ height: "100%", alignItems: "center", p: 2 }}>
        <Grid item sm={12}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box>
              <TicketsFilter
                pageName={"tickets"}
                getFilterDetails={(data) => {
                  setFilterData(data);
                }}
              />
            </Box>

            <Box>
              <ProjectvariantSearchbar />
            </Box>

            <ProjectVariantDialog />
          </Box>
        </Grid>
        <CustomTabsV2
          onTabChange={handleTabChange}
          centerTabs={true}
          defaultTab={tabFromUrl || 0}
          tabs={[
            {
              name: "Vehicle System",
              count: "",
              content: (
                <TicketsTable
                  tickets_type={TICKETS_TYPES.VEHICLE_SYSTEM}
                  ticketDetails={ticketDetails}
                  selectedTicketType={selectedTicketType}
                  setSelectedTicketType={setSelectedTicketType}
                  selectedIntersectionIds={selectedIntersectionIds}
                  setSelectedIntersectionIds={setSelectedIntersectionIds}
                  totalCount={totalCount}
                  fetchTickets={fetchTickets}
                  enableAction={true}
                  showPagination={true}
                  filterData={filterData}
                  parentPage="tickets"
                />
              ),
            },
            {
              name: "Vehicle Component",
              count: "",
              content: (
                <TicketsTable
                  tickets_type={TICKETS_TYPES.VEHICLE_COMPONENT}
                  ticketDetails={ticketDetails}
                  selectedTicketType={selectedTicketType}
                  setSelectedTicketType={setSelectedTicketType}
                  selectedIntersectionIds={selectedIntersectionIds}
                  setSelectedIntersectionIds={setSelectedIntersectionIds}
                  totalCount={totalCount}
                  fetchTickets={fetchTickets}
                  enableAction={true}
                  showPagination={true}
                  filterData={filterData}
                  parentPage="tickets"
                />
              ),
            },
            {
              name: "EE Component",
              count: "",
              content: (
                <TicketsTable
                  tickets_type={TICKETS_TYPES.EE}
                  ticketDetails={ticketDetails}
                  selectedTicketType={selectedTicketType}
                  setSelectedTicketType={setSelectedTicketType}
                  selectedIntersectionIds={selectedIntersectionIds}
                  setSelectedIntersectionIds={setSelectedIntersectionIds}
                  totalCount={totalCount}
                  fetchTickets={fetchTickets}
                  enableAction={true}
                  showPagination={true}
                  filterData={filterData}
                  parentPage="tickets"
                />
              ),
            },
            {
              name: "Software Module",
              count: "",
              content: (
                <TicketsTable
                  tickets_type={TICKETS_TYPES.SWM}
                  ticketDetails={ticketDetails}
                  selectedTicketType={selectedTicketType}
                  setSelectedTicketType={setSelectedTicketType}
                  selectedIntersectionIds={selectedIntersectionIds}
                  setSelectedIntersectionIds={setSelectedIntersectionIds}
                  totalCount={totalCount}
                  fetchTickets={fetchTickets}
                  enableAction={true}
                  showPagination={true}
                  filterData={filterData}
                  parentPage="tickets"
                />
              ),
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default TicketsIndex;
